module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/DMS_DVR_360 Degree Panorama_OMS.c24d377e.png";